import { Box, Chip, FormControl, InputLabel, MenuItem, OutlinedInput, Select } from "@mui/material"
import { makeStyles } from "@mui/styles";
import CustomDialog from "components/Dialogs/MasterDialog"
import FormMonitoring from "components/FormMonitoring"
import { CommonTexts, contentTexts } from "locale/es"
import { useState } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import { AppColors } from "resources/AppColors"
import { useDispatch, useSelector } from "react-redux";

const useStyles = makeStyles((theme) => ({
  textFieldLabel: {
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: AppColors.PRIMARY,
      },
    },
    "& .MuiInputBase-root": {
      color: AppColors.PRIMARY,
    },
    "& .MuiInputLabel-root": {
      color: AppColors.PRIMARY,
    },
    color: AppColors.PRIMARY,
    backgroundColor: AppColors.BOX_FILL,
  },
}));

function DuplicateContentForm({ updateContent }) {
  const { user } = useSelector(state => state.userAuthentication)

  const { entity } = useLocation().state

  const centers = user.centers

  const [selectedCenters, setSelectedCenters] = useState(
    centers.filter(center => entity.centers.some(selectedCenter => selectedCenter.id === center.id))
  )

  const dispatch = useDispatch()

  const navigate = useNavigate()

  const classes = useStyles();

  function handleOnConfirmDuplicateContent() {
    dispatch(updateContent({ id: entity.id, centers: selectedCenters.map(center => { return { id: center.id } }) }))
    handleShowExitModal()
  };

  function handleSelectCenters(event) {
    const {
      target: { value },
    } = event;

    if (value[value.length - 1] === "all") {
      setSelectedCenters(selectedCenters.length === centers.length ? [] : centers);
      return;
    }

    setSelectedCenters(
      // On autofill we get a stringified value.
      typeof value === 'string' ? value.split(',') : value,
    );
  }

  function resetFormInputs() {
    setSelectedCenters(entity.centers)
  }

  function handleShowExitModal() {
    navigate('/contingut/management')
  }

  return (
    <CustomDialog
      title={contentTexts.DUPLICATE_CENTER}
      show={true}
      handleShow={handleShowExitModal}
    >
      <FormMonitoring
        submitForm={handleOnConfirmDuplicateContent}
        resetFormInputs={resetFormInputs}
        isEdit
      >
        <FormControl required sx={{ mt: 2, mb: 1 }} className={classes.textFieldLabel}>
          <InputLabel id="select-centers-label">{CommonTexts.CENTERS}</InputLabel>
          <Select
            labelId="center-selector-label"
            id="centers-selector"
            variant="outlined"
            value={selectedCenters}
            label={CommonTexts.CENTERS}
            onChange={handleSelectCenters}
            input={<OutlinedInput id="select-multiple-chip" label="Chip" />}
            multiple
            renderValue={(selected) => (
              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                {selected.map((value) => (
                  <Chip key={value.id} label={value.name} />
                ))}
              </Box>
            )}
          >
            <MenuItem value='all'>
              <em><strong>{contentTexts.SELECT} {CommonTexts.CENTERS}</strong></em>
            </MenuItem>
            {centers.map(center => <MenuItem key={center.id} value={center}>{center.name}</MenuItem>
            )}
          </Select>
        </FormControl>
      </FormMonitoring>
    </CustomDialog>
  )
}

export default DuplicateContentForm